import { render } from "./ProfilePageSkeleton.vue?vue&type=template&id=5ff2e60e&ts=true"
import script from "./ProfilePageSkeleton.vue?vue&type=script&lang=ts"
export * from "./ProfilePageSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__